import { render, staticRenderFns } from "./ActivityPopup.vue?vue&type=template&id=81e1ec6c&scoped=true"
import script from "./ActivityPopup.vue?vue&type=script&lang=js"
export * from "./ActivityPopup.vue?vue&type=script&lang=js"
import style0 from "./ActivityPopup.vue?vue&type=style&index=0&id=81e1ec6c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e1ec6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81e1ec6c')) {
      api.createRecord('81e1ec6c', component.options)
    } else {
      api.reload('81e1ec6c', component.options)
    }
    module.hot.accept("./ActivityPopup.vue?vue&type=template&id=81e1ec6c&scoped=true", function () {
      api.rerender('81e1ec6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemAdministrator/activityCreation/components/ActivityPopup.vue"
export default component.exports